module.exports = __webpack_public_path__ + "img/guessLoveIcon.5d818aab.png";